// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"about-author_imageContainer__OfEJX","largeImageContainer":"about-author_largeImageContainer__ESZCZ"};